import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: SkillPracState = {
  visible: false,
  professionId: ''
};

export interface SkillPracState {
  visible: boolean,
  professionId: string
}

export const slice = createSlice({
  name: 'skillPrac',
  initialState: initialState,
  reducers: {
    show: (state, action: PayloadAction<string>) => {
      state.visible = true;
      state.professionId = action.payload;
    },
    hide: (state) => {
      state.visible = false;
    }
  }
});

export default slice.reducer;
export const { show, hide } = slice.actions;
